export function getFileName(url) {
    var filename = url.split("/").pop();
    return filename;
}
